import { useParams } from "react-router-dom";

const useContentFormParams = () => {
  const { mode: formMode, group: groupId, id: contentId } = useParams();
  const isParent = window.location.pathname.includes("/clubadmin/");
  return { formMode, groupId, contentId, isParent };
};

export default useContentFormParams;
